module.exports = {
	"articleTitle1": "Opinions of Northwood III housing mixed",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Northwood III",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/upperclassman-relocation-worries-parents",
	"articleSnippet1": "Jan 20, 2006 ... Sitting on the wood floor in the living room of her cozy two-bedroom apartment in \nthe Northwood III housing complex on North Campus, Art and ...",
	"articleSnippet2": "Sep 7, 2004 ... Despite this incident, Suhail said the recent move-in of undergraduates from Vera \nBaits Residence Hall into Northwood I, II, and III has not been ...",
	"totalMisc": 0,
	"articleTitle2": "Upperclassman relocation worries parents",
	"address": "2150 Cram Pl, Ann Arbor, MI 48105",
	"images": [],
	"position": {
		"lat": 42.296852,
		"lng": -83.717287
	},
	"tips": [
		{
			"text": "Especially during the summer, you can see ducks, groundhogs, skunks (run for your life if you see it), deers and anorexic squirrels. There are Northwood I~V, and (upperclassmen) undergrads usually live at Northwood III.",
			"person": "Patricia Huang"
		}
	],
	"bathroomrating": [],
	"categories": {
		"dorm": 1,
		"misc": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/northwood3.json
// module id = 934
// module chunks = 0